import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthSubscription } from '@features/auth/hooks';
import { RequireAuth } from './guards/RequireAuth';
import { RequireRole } from './guards/RequireRole';
import { RedirectIfAuthed } from './guards/RedirectIfAuthed';
import { AppShell } from '@components/layout/AppShell';
import { BootSplash } from '@components/layout/BootSplash';
import LoginScreen from '@screens/LoginScreen';
import HomeScreen from '@screens/HomeScreen';
import ApmcsScreen from '@screens/ApmcsScreen';
import CropsScreen from '@screens/CropsScreen';
import ForecastsScreen from '@screens/ForecastsScreen';
import ForecastRunsScreen from '@screens/ForecastRunsScreen';
import MarketClosuresScreen from '@screens/MarketClosuresScreen';
import MarketPricesScreen from '@screens/MarketPricesScreen';
import NewsArticlesScreen from '@screens/NewsArticlesScreen';
import PriceReviewScreen from '@screens/PriceReviewScreen';
import PriceSeriesScreen from '@screens/PriceSeriesScreen';
import TagsScreen from '@screens/TagsScreen';
import UiStringsScreen from '@screens/UiStringsScreen';
import VarietiesScreen from '@screens/VarietiesScreen';

export default function AppRoutes() {
  useAuthSubscription();

  return (
    <>
      <BootSplash />
      <Routes>
        <Route element={<RedirectIfAuthed />}>
          <Route path="/login" element={<LoginScreen />} />
        </Route>

        <Route element={<RequireAuth />}>
          <Route element={<AppShell />}>
            {/* Open to every admin-panel role (admin, tech_team, business_team). */}
            <Route path="/home" element={<HomeScreen />} />
            <Route path="/news-articles" element={<NewsArticlesScreen />} />
            <Route path="/tags" element={<TagsScreen />} />
            <Route path="/market-prices" element={<MarketPricesScreen />} />
            <Route path="/price-review" element={<PriceReviewScreen />} />
            <Route path="/price-series" element={<PriceSeriesScreen />} />
            <Route path="/forecasts" element={<ForecastsScreen />} />

            {/* Master data — open to every admin-panel role, incl. business_team
                (full edit). Mirrors the backend controllers' entitlements. */}
            <Route path="/crops" element={<CropsScreen />} />
            <Route path="/varieties" element={<VarietiesScreen />} />
            <Route path="/apmcs" element={<ApmcsScreen />} />
            <Route path="/market-closures" element={<MarketClosuresScreen />} />
            <Route path="/ui-strings" element={<UiStringsScreen />} />

            {/* admin + tech_team only — must mirror @RequireEntitlements on
                the matching backend controllers. */}
            <Route element={<RequireRole allowed={['admin', 'tech_team']} />}>
              <Route path="/forecasts/runs" element={<ForecastRunsScreen />} />
            </Route>
          </Route>
        </Route>

        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="*" element={<div className="p-8">404 — Not Found</div>} />
      </Routes>
    </>
  );
}
